
export default {
    name: 'IsOffline',
    data() {
        return {}
    },
}
